import(/* webpackMode: "eager" */ "/Users/vijay/Desktop/sst-internationals/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/Users/vijay/Desktop/sst-internationals/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/Users/vijay/Desktop/sst-internationals/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/Users/vijay/Desktop/sst-internationals/node_modules/bootstrap/dist/css/bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "/Users/vijay/Desktop/sst-internationals/node_modules/bootstrap-icons/font/bootstrap-icons.css");
;
import(/* webpackMode: "eager" */ "/Users/vijay/Desktop/sst-internationals/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/app/ClientLayout.js");
;
import(/* webpackMode: "eager" */ "/Users/vijay/Desktop/sst-internationals/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/Users/vijay/Desktop/sst-internationals/node_modules/antd/dist/reset.css");
;
import(/* webpackMode: "eager" */ "/Users/vijay/Desktop/sst-internationals/node_modules/slick-carousel/slick/slick.css");
;
import(/* webpackMode: "eager" */ "/Users/vijay/Desktop/sst-internationals/node_modules/slick-carousel/slick/slick-theme.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/vijay/Desktop/sst-internationals/src/components/MetaPixel.js");
